import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_8: FaireProductEntity = {
  token: "atc_updated_fs_rec_8",
  type: "product",
  name: "Glossy Black Wall Organizer",
  brandName: "Faire Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4bc222bc7bbca8d05a9ed355ddc03959a119e051357d96a307f91cce0aa38a4d.webp",
  priceDollars: 45,
  msrpDollars: 58,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
